import { createClient } from '@supabase/supabase-js';
import logger from '../utils/logger';

// These values must be set in .env (development) or .env.production (production).
// Never hardcode Supabase keys in source — they end up in the production bundle.
const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  logger.error(
    'Supabase env vars missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Helper function to synchronize user with Django backend
export const syncUserWithDjango = async (userData) => {
  try {
    const { data, error } = await supabase.functions.invoke('sync-user-with-django', {
      body: userData,
    });
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    logger.error('Error syncing user with Django:', error);
    return { data: null, error };
  }
};
